import { AccountDetail } from '../models/amway';
import { ABOBusinessDetails } from '../models/abo-business-details.model';

export function getAboBasicBusinessDetails(accountDetail: AccountDetail) {
     if (accountDetail && accountDetail.data) {
         return new ABOBusinessDetails(accountDetail.data.accountMst, accountDetail.data.sponsor, accountDetail.data.currentParty);
     }
     return {} as ABOBusinessDetails;
}
